import { render } from "./insiemeperlambiente.vue?vue&type=template&id=55959f4f"
const script = {}

import "./insiemeperlambiente.vue?vue&type=style&index=0&lang=css"
script.render = render
/* custom blocks */
import block0 from "./insiemeperlambiente.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script